import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Studio from "./pages/Studio";
import Videos from "./pages/Videos";
import Account from "./pages/Account";
import Payment from "./pages/Payment";
import Gallery from "./pages/Gallery";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-zinc-500" data-testid="auth-loading">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/precios" element={<Landing section="precios" />} />
          <Route path="/muestras" element={<Landing section="muestras" />} />
          <Route path="/funciones" element={<Landing section="funciones" />} />
          <Route path="/crear-videos-automaticos-sin-ia" element={<Landing section="funciones" />} />
          <Route path="/galeria" element={<Protected><Gallery /></Protected>} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/studio" element={<Protected><Studio /></Protected>} />
          <Route path="/videos" element={<Protected><Videos /></Protected>} />
          <Route path="/account" element={<Protected><Account /></Protected>} />
          <Route path="/payment/:kind" element={<Protected><Payment /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
